import React, { forwardRef } from 'react';
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon';

const TypeDigitSlide = forwardRef<SVGSVGElement, SvgIconProps>((props, ref) => (
  <SvgIcon {...props} ref={ref} viewBox="0 0 24 24">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0857 8.14283C9.95548 8.14283 8.22857 9.86973 8.22857 12C8.22857 14.1302 9.95548 15.8571 12.0857 15.8571C14.216 15.8571 15.9429 14.1302 15.9429 12C15.9429 9.86973 14.216 8.14283 12.0857 8.14283ZM6.78356 10.9714C7.26383 8.48101 9.4551 6.59998 12.0857 6.59998C14.7163 6.59998 16.9076 8.48101 17.3879 10.9714H22.3714V13.0285H17.3879C16.9076 15.5189 14.7163 17.4 12.0857 17.4C9.4551 17.4 7.26383 15.5189 6.78356 13.0285H1.8V10.9714H6.78356Z"
    />
  </SvgIcon>
));

TypeDigitSlide.displayName = 'TypeDigitSlide';

export default TypeDigitSlide;
